import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    border: '1px solid #000',
    marginTop: '10px',
    padding: '15px'
  },
  time: {
    fontSize: '14px',
    fontWeight: 'bold'
  },
  meeting: {
    fontSize: '14px'
  },
  detailsLink: {
    fontSize: '14px',
    fontWeight: 'bold',
    color: '#002380',
    cursor: 'pointer'
  }
}));

const Meeting = ({ time, meeting }) => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <h3 className={classes.time}>{time}</h3>
      <p className={classes.meeting}>{meeting}</p>
      <p className={classes.detailsLink}>See details</p>
    </div>
  );
};

export default Meeting;
